import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonControlsModule } from '../common-controls/common-controls.module';
import { RomeLibraryModule } from '../lib/rome-library.module';
import { RomeKendoModule } from '../rome-kendo/rome-kendo.module';
import { ProductPickerListViewComponent } from './components/product-picker-list-view/product-picker-list-view.component';
import { ProductPickerSearchCriteriaComponent } from './components/product-picker-search-criteria/product-picker-search-criteria.component';
import { TermInputComponent } from './components/term-input/term-input.component';
import { AdvisedIllustrationStore } from './services/advised-illustration-store';
import { ProductPickerService } from './services/product-picker.service';

const COMPONENTS = [ProductPickerListViewComponent, ProductPickerSearchCriteriaComponent, TermInputComponent];

@NgModule({
  declarations: [COMPONENTS],
  imports: [CommonModule, RomeKendoModule, RomeLibraryModule, CommonControlsModule, FormsModule],
  providers: [ProductPickerService, AdvisedIllustrationStore],
  exports: [COMPONENTS]
})
export class ProductPickerControlsModule {}
